import { axios } from "../axiosInstance";

export interface SuccessStoryLogo {
  href: string;
  src: string;
}

export interface SuccessStoryView {
  id: number;
  title: string;
  bodyHtml: string;
  quotesHtml: string;
  showMeta: boolean;
  attribution: string;
  pressLink: string;
  logos: SuccessStoryLogo[];
}

export interface SuccessStoryList {
  stories: SuccessStoryView[];
}

export async function getSuccessStories(storyId: string): Promise<SuccessStoryList> {
  const search = new URLSearchParams();
  if (storyId) {
    search.set("n1", storyId);
  }
  const query = search.toString();
  const response = await axios.Get(`./publicSuccessStories${query ? `?${query}` : ""}`);
  return response.data as SuccessStoryList;
}
